<template>
  <!-- <div class="sidebar-wrapper"> -->
  <el-aside class="sidebar-wrapper sidebar-transition" :width="asideWidth">
    <div class="sidebar-inner" :style="{
      width: isCollapse ? '65px' : '160px',
      transition: 'width  0.2s ease-out',
    }">
      <el-menu :default-openeds="['2']" :default-active="defaultActive" class="el-menu-vertical-demo"
        :unique-opened="true" @open="handleOpen" @close="handleClose" :collapse="true">
        <el-submenu :index="(item.id - item.studentPageId).toString()" v-for="item in menuChildsData" :key="item.id"
          style="border-bottom: 1px solid var(--UnderlineColor)">
          <template slot="title">
            <!-- 只有一级菜单 -->
            <div v-if="item.childs && item.childs == null && item.childs.length == 0" @click="
              addTabC({
                name: item.id.toString(),
                id:item.id,
                title: item.name,
                remarks: item.remarks,
                prompt: true,
                component: item.componentName,
                studentPageId: item.studentPageId,
                index: (item.id - item.studentPageId).toString()
              })
              " class="one">
              <i :class="item.icon"></i>
              <b v-show="!isCollapse" class="menu_one_text">{{ item.name }}</b>
            </div>
            <!-- 存在多级菜单 -->
            <div v-else>
              <i :class="item.icon"></i>
              <b v-show="!isCollapse" class="menu_one_text">{{ item.name }}</b>
            </div>
          </template>
          <!-- 二级菜单 -->
          <div class="sidear_container">
            <template v-for="two in item.childs">
              <el-menu-item :index="(two.id - two.studentPageId).toString()" @click="
                addTabC({
                  name: two.id.toString(),
                  id:two.id,
                  title: two.name,
                  remarks: two.remarks,
                  prompt: true,
                  component: two.componentName,
                  studentPageId: two.studentPageId,
                  index: (two.id - two.studentPageId).toString()
                })
                " :key="(two.id - two.studentPageId).toString()" v-if="two.childs && two.childs.length == 0">
                <i style="color: #333" :class="two.icon"></i>{{ two.name }}
              </el-menu-item>
              <!-- //二三级菜单显示 -->
              <template v-else>
                <el-submenu :key="two.orders" :index="two.id.toString()" class="three_tree" :popper-append-to-body="true"
                  style="border-bottom: 1px solid #eeeff1">
                  <template slot="title">
                    <div style="display: flex;justify-content: space-between;align-items:center">
                      <div>
                        <i style="color: #333" :class="two.icon"></i>
                        <span slot="title">{{ two.name }}</span>
                      </div>
                      <div class="menu_num">{{ two.childs.length }}</div>
                    </div>
                  </template>
                  <!-- //三四级菜单循环 -->
                  <div class="sidear_container">
                    <div v-for="three in two.childs" :key="three.id" class="three_four">
                      <!-- 四级菜单显示 -->
                      <el-submenu :index="three.id.toString()" v-if="three.childs && three.childs.length > 0">
                        <template slot="title">
                          <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>
                              <i style="color: #333" :class="three.icon"></i>
                              <span slot="title">{{ three.name }}</span>
                            </div>
                            <!--<el-button type="primary" style="height:30px;line-height:8px;margin-right: 15px;" circle>{{
                              three.childs.length }}</el-button>-->
                            <div class="menu_num">{{ three.childs.length }}</div> <!-- 子菜单数量 -->
                          </div>
                        </template>
                        <el-menu-item v-for="four in three.childs" :key="four.id" :index="four.id.toString()" @click="
                          addTabC({
                            name: four.id.toString(),
                            id:four.id,
                            title: four.name,
                            remarks: four.remarks,
                            prompt: true,
                            component: four.componentName,
                            index: four.id.toString()
                          })
                          ">
                          <i :class="four.icon"></i>{{ four.name }}</el-menu-item>
                      </el-submenu>
                      <!-- 三级 -->
                      <el-menu-item v-else :index="three.id.toString()" @click="
                        addTabC({
                          name: three.id.toString(),
                          id:three.id,
                          title: three.name,
                          remarks: three.remarks,
                          prompt: true,
                          component: three.componentName,
                          index: three.id.toString()
                        })
                        ">
                        <i :class="three.icon"></i>{{ three.name }}
                      </el-menu-item>
                    </div>
                  </div>
                </el-submenu>
              </template>
            </template>
          </div>
        </el-submenu>
      </el-menu>

      <div class="sidebar-collapse-btn" :class="{ isLeftClick: isLeftClick }" @click="openClick">
        <i class="el-icon-caret-left" v-show="!isCollapse"></i>
        <i class="el-icon-caret-right" v-show="isCollapse"></i>
      </div>
    </div>
  </el-aside>
  <!-- </div> -->
</template>

<script>
import { loginRoleInformation, GetTheMenuById } from "network/login";
import { loginRoleInformationV2 } from "network/projectLogin";
import { filter, conforms } from "lodash";
import { GetAdminLoginTokenAsync,GetAdminLoginToken } from "network/administrator";
export default {
  name: "SideBar",
  props:{
    ready:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      isCollapse: false,
      isLeftClick: false,
      menuChildsData: [], //登录的管理员菜单数据
      defaultActive: "1-1-1", //默认选中菜单
      isInitialized: false,
    };
  },
  watch:{
    ready: {
      handler(val) {
        if (val && !this.isInitialized) {
          this.isInitialized = true;
          this.getMenuChildsData();
        }
      },
      immediate: true,
        
    },

  },

  mounted() {
      // 如果 ready 为 true 且未初始化，立即执行
      if (this.ready && !this.isInitialized) {
        this.isInitialized = true;
        this.getMenuChildsData();
      }
  },

  computed: {
    asideWidth() {
      return this.isCollapse ? "65px" : "160px";
    },
    asideInnerWidth() {
      return this.isCollapse ? "65px" : "160px";
    },
    // 获取管理员身份
    AdminCache() {
      return (
        this.$store.state.AdminCache || sessionStorage.getItem("AdminCache")
      );
    },
  },
  methods: {
    // 点击头部菜单时，同步左侧菜单
    setActive(val) {
      if(this.defaultActive === val) {
        this.defaultActive = ''
        this.$nextTick(() => {
          this.defaultActive = val
        })
      } else {
        this.defaultActive = val
      }
    },
    //获取登录的管理员菜单数据
    async getMenuChildsData() {
      const result = await loginRoleInformationV2();
      if (result.code == 1) {
        const res = await GetTheMenuById();
        sessionStorage.setItem("theMenuChilds", JSON.stringify(res.result.theMenuList)); //存储
        // 触发菜单数据加载完成事件
        this.$root.$emit('menuDataLoaded');
        const defaultMenuId = res.result.defaultTheMenuId;
        // 递归遍历寻找默认菜单
        const processChilds = (childs) => {
          for(const child of childs) {
            if (child.id === defaultMenuId) {
              child.component = child.componentName;
              this.defaultActive = (child.id - child.studentPageId).toString()
              this.$emit("default-Page", child)
              return true
            }
            if (child.childs && child.childs.length > 0) {
              if(processChilds(child.childs)) return true
            }
          }
        }
        if(!defaultMenuId || !processChilds(res.result.theMenuList)) {
          this.$message.warning("未设置默认菜单");
        }
        this.menuChildsData = res.result.theMenuList
      } else {
        if (result.message) {
          this.$message.error(result.message);
        }
      }
    },
    // 左侧菜单展开收起
    openClick() {
      this.isLeftClick = !this.isLeftClick;
      this.isCollapse = !this.isCollapse;
      // this.$emit('open-menu', this.isCollapse)
    },
    // 左侧菜单当前展开项
    handleOpen(key, keyPath) {
    },
    // 左侧菜单当前收起项
    handleClose(key, keyPath) {
    },
    // 新开窗口tab
    async addTabC(tabObj) {
      // 打开页面存储
      let newTabObj = {}
      const currentMenuIsPrompt = localStorage.getItem('currentMenuIsPrompt') ?
          JSON.parse(localStorage.getItem('currentMenuIsPrompt')) : []
      const arr = filter(currentMenuIsPrompt, conforms({ 'title': n => { return n === tabObj.title} }));
      if (arr.length > 0) {
        arr.forEach(item => {
          if (item?.title === tabObj.title) {
            newTabObj = {
              ...tabObj,
              prompt: item.prompt
            }
          } else {
            newTabObj = tabObj
          }
        })
      }else {
        newTabObj = tabObj
      }
      sessionStorage.setItem("tabObj", JSON.stringify(newTabObj));

      if (tabObj.component == "url") {
        //配置中心
        if (this.$store.state.allConfig) {
          var url = this.$store.state.allConfig.apolloAddress;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url = JSON.parse(
            sessionStorage.getItem("allConfig")
          ).apolloAddress;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      } else if (tabObj.component == "urlHangfire") {
        //任务中心
        if (this.$store.state.allConfig) {
          var url = this.$store.state.allConfig.hangfireOpenUrl;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url = JSON.parse(
            sessionStorage.getItem("allConfig")
          ).hangfireOpenUrl;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      } else if (tabObj.component == "urlGateway") {
        //网关接口文档
        if (this.$store.state.allConfig) {
          var url =
            this.$store.state.allConfig.backgroundGatewayAddress;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url =
            JSON.parse(sessionStorage.getItem("allConfig"))
              .backgroundGatewayAddress;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      } else if (tabObj.component == "urlExceptionless") {
        //日志系统
        if (this.$store.state.allConfig) {
          var url = this.$store.state.allConfig.exceptionlessUrl;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url = JSON.parse(
            sessionStorage.getItem("allConfig")
          ).exceptionlessUrl;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      } else if (tabObj.component == "urlRabbitMQ") {
        //事务中心
        if (this.$store.state.allConfig) {
          var url = this.$store.state.allConfig.rabbitMQAdminUrl;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url = JSON.parse(
            sessionStorage.getItem("allConfig")
          ).rabbitMQAdminUrl;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      } else if (tabObj.component == "studentsAttendance") {
        window.open("/#/RadarStudentsAttendance", "_blank");
      } else if (tabObj.component == "AshoreRanking") {
        window.open("/#/AshoreRanking", "_blank");
      } else if (tabObj.component == "LearnBigData") {
        window.open("/#/LearnBigData", "_blank");
      } else if (tabObj.component == "classAttendance") {
        window.open("/#/RadarClassAttendance", "_blank");
      } else if (tabObj.component == "ExplosiveClassroom") {
        window.open("/#/ExplosiveClassroom", "_blank");
      } else if (tabObj.component == "EarningReport") {
        this.getNewToken("/#/EarningReport")
      }else if (tabObj.component == "PaymentManagement") {
        this.getNewToken("/#/PaymentManagement", "_blank");
      }else if (tabObj.component == "MarkExampapers") {
        this.getNewToken("/#/MarkExampapers", "_blank");
      }else if (tabObj.component == "InformationStudentListNew") {
        this.getNewToken("/#/InformationStudentListNew", "_blank");
      }else if (tabObj.component == "CourseConversionStudentListNew") {
        this.getNewToken("/#/CourseConversionStudentListNew", "_blank");
      } else if (tabObj.component == "AssignAccessStudentList") {
        this.getNewToken("/#/AssignAccessStudentList", "_blank");
      } else if (tabObj.component == "AssignAccessStudentList") {
        this.getNewToken("/#/DistributionWeightStudentList", "_blank");
      } else if (tabObj.component == "PersonalHonorReport") {
        window.open("/#/PersonalHonorReport", "_blank");
      } else {
        this.$emit("add-tab", newTabObj);
      }
      // this.getButton()
    },
    // 打开新页面获取新token（兼容部分浏览器：使用 localStorage 以便新标签页可读取）
    async getNewToken(tabName, target = "_blank"){
      const result = await GetAdminLoginTokenAsync(this.AdminCache.adminId,true);
      if(result.code == 1){
        const res1 = await GetAdminLoginToken({ key: result.result });
        let res = res1.data || res1
        if (res.code == 1 && res?.result?.access_token) {
          const tokenStr = JSON.stringify(res.result);
          try {
            // 使用 localStorage 让新打开的标签页也能读取到 token
            localStorage.setItem("AdminToken", tokenStr);
            // 同时写入 sessionStorage 以兼容原有逻辑（不会影响新标签）
            sessionStorage.setItem("AdminToken", tokenStr);
          } catch (e) {
            // 某些无痕/受限环境可能抛出，忽略写入错误
          }
          // 打开新窗口/标签
          window.open(tabName, target);
          // 延迟清除，给新页面留出读取时间（例如通过 mounted 或 storage 事件读取）
          setTimeout(() => {
            try {
              localStorage.removeItem("AdminToken");
              sessionStorage.removeItem("AdminToken");
            } catch (e) {}
          }, 2000);
        } else {
          this.$alert(res.message || "暂无权限");
        }
      }else{
        this.$alert("暂无权限");
      }
    },
    // 获取页面按钮
    async getButton() {
      try {
        this.buttonLoading = true
        const tabObj = sessionStorage.getItem('tabObj') ? JSON.parse(sessionStorage.getItem('tabObj')) : {}
        const res = await this.getOperationList(tabObj.name)
        this.buttonLoading = false
        if (res.code) {
          // this.buttonList = res.result
          // sessionStorage.setItem('buttonList', JSON.stringify(res.result))
        }
      } catch (e) {
        this.buttonLoading = false
      }
    },
  },
};
</script>

<style>
.sidebar-inner .isLeftClick {
  left: 47px;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active 用于 2.1.8 以下版本 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.sidebar-transition {
  transition: width 0.3s;
  -moz-transition: width 0.3s;
  /* Firefox 4 */
  -webkit-transition: width 0.3s;
  /* Safari and Chrome */
  -o-transition: width 0.3s;
  /* Opera */
}

.sidebar-inner,
.el-menu-vertical-demo {
  background-color: var(--SliderMenuColor, "#eef1f6");
}

.sidebar-inner {
  /* width: 200px; */
  height: 100%;
  /* position: relative; */
  overflow-x: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  min-height: 400px;
}

.el-menu--collapse>.el-menu-item span,
.el-menu--collapse>.el-submenu>.el-submenu__title span {
  display: inline-block;
  margin-left: 19px;
  width: auto;
  height: 50px;
  visibility: visible;
}

.el-menu-item,
.el-submenu__title {
  line-height: 50px !important;
}

.sidebar-collapse-btn {
  position: fixed;
  top: 50%;
  left: 162px;
  width: 18px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  margin-top: -24px;
  /* border: 1px soid var(--SliderMenuColor); */
  background-color: var(--SliderMenuColor);
  border-radius: 24px 0 0 24px;
  cursor: pointer;
  transition: left 0.3s;
}

.sidebar-collapse-btn i {
  color: var(--MenuFontColor, "#5b6a82");
}

.el-menu--vertical .three_tree:last-child {
  border-bottom: none;
}

li.el-menu-item {
  border-bottom: 1px solid #eeeff1;
}

.two_menu {
  background-color: #fff;
}

.two_menu .el-submenu {
  background-color: #fff;
  border-bottom: 1px solid #ebe7e7 !important;
}

.is-opened .el-menu--inline {
  border-top: 1px solid #eeeff1;
}

.is-opened .el-menu li:last-child {
  border-bottom: none !important;
}

.two_menu .el-submenu__icon-arrow {
  display: none;
}

.two_menu .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #eeeff1;
}

.el-submenu__title {
  height: 50px !important;
}

.el-submenu.is-opened>>>.el-submenu__title .el-icon-arrow-right {
  transform: rotateZ(-90deg);
}

.one+.el-submenu__icon-arrow.el-icon-arrow-down {
  /* transform: rotateZ(-90deg) !important; */
}

.el-sub-menu.is-opened>>>.el-sub-menu__title .el-icon-arrow-right {
  transform: rotateZ(-90deg);
}

.one+.el-sub-menu__icon-arrow.el-icon-arrow-down {
  transform: rotateZ(-90deg) !important;
}

.el-sub-menu .el-menu-item::before {
  width: 0;
}

.sidebar-inner .el-sub-menu .el-menu-item {
  padding: 0 45px;
  min-width: 150px;
  height: 50px;
}

.sidebar-inner .el-menu--collapse {
  width: 100% !important;
  background-color: var(--SliderMenuColor, "#eef1f6");
}

/* //选中字体颜色 未选中字体、icon */
::v-deep .el-menu-vertical-demo .is-active .el-sub-menu__title,
.el-menu-vertical-demo ::v-deep .el-sub-menu__title .onelevel_menu,
.el-sub-menu .el-icon {
  color: #fff;
}

/* // 次级菜单字体颜色 */
.el-menu-item.is-active {
  color: #000;
}

/* // 菜单名称 */
.onelevel_menu {
  display: inline-block;
  margin-left: 19px;
}

.el-menu--collapse .el-sub-menu {
  border-bottom: 1px solid #4f5154;
}

/* 选中菜单背景色 */
.el-submenu.is-active {
  background-color: #e9e9e9 !important;
}

/* 二级选中菜单背景色 */
.el-menu-item.is-active {
  background-color: #e9e9e9 !important;
}

/* 一级菜单字体颜色 */
.el-submenu:hover .menu_one_text {
  color: #333 !important;
}

.is-active .menu_one_text {
  color: #333 !important;
}

.menu_one_text {
  font-style: normal;
  font-weight: normal;
  margin-left: 10px;
  color: var(--MenuFontColor) !important;
}

/* 图标跟随字体颜色 */
/* .el-submenu__title i {
  color: var(--MenuFontColor) !important;
} */
.el-submenu:hover .el-submenu__title i {
  color: #333 !important;
}

.is-active .el-submenu__title i {
  color: #333 !important;
}

/* 菜单数目 */
.menu_num {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--ThemeColor) !important;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

/* // 鼠标经过竖条样式 */
.sidebar-inner .el-submenu:hover::before {
  content: "";
  width: 6px;
  height: 50px;
  display: inline-block;
  background-color: var(--ThemeColor, "#91b9e7") !important;
  position: absolute;
  left: 0;
  z-index: 2;
  border-radius: 0px 3px 3px 0px;
}

/* // 二级菜单高度设置 */
.el-sub-menu,
.menu_no_child,
::v-deep .el-sub-menu__title,
.childs_heigth.el-menu-item {
  height: 50px;
}

/* // 选中竖条色 */
.sidebar-inner .el-submenu.is-active::before {
  content: "";
  width: 6px;
  height: 50px;
  display: inline-block;
  background-color: var(--ThemeColor, "#91b9e7") !important;
  position: absolute;
  left: 0;
  z-index: 2;
  border-radius: 0px 3px 3px 0px;
}

/* //  选中左边竖条颜色 */
.sidebar-inner .el-menu--vertical .el-menu--popup .is-active::before {
  content: "";
  width: 6px;
  height: 50px;
  background-color: var(--ThemeColor, "#91b9e7") !important;
  position: absolute;
  left: 0;
  border-radius: 0px 3px 3px 0px;
  z-index: 9999;
}

/* 左侧菜单收起展开图标 */
.sidebar-collapse-btn {
  position: fixed;
  top: 50%;
  left: 160px;
  width: 15px;
  height: 53px;
  line-height: 53px;
  text-align: center;
  margin-top: -24px;
  /* border: 1px solid var(--ThemeColor, "#91b9e7"); */
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  transition: left 0.05s;
  z-index: 2;
}

/* // 侧边栏隐藏按钮背景色 */
.sidebar-collapse-btn {
  background-color: var(--SliderMenuColor, "#d4d7de");
  color: #fff;
}

.sidebar-inner .isLeftClick {
  left: 65px;
  transition: 0.05s;
}

/* // 仅存在一个菜单的情况 */
.menu_no_child,
::v-deep .menu_no_child .el-icon {
  color: #fff;
}

.menu_no_child.is-active {
  color: #fff;
  border-bottom: 1px solid #4f5154;
  background-color: #131d29 !important;
}

.menu_no_child.el-menu-item:hover {
  background-color: #131d29 !important;
}

/* 二级菜单 */
.el-menu--vertical {
  margin-left: -4px;
}

.el-menu--vertical icon {
  color: #000;
}

.el-menu-item {
  height: 50px !important;
}

.el-menu--popup .el-menu-item:last-child {
  border-bottom: none;
}

.three_four {
  border-bottom: 1px solid #eeeff1;
}

.el-menu--popup .three_four:last-child {
  border-bottom: none;
}

.el-menu--popup {
  padding: 0;
}

/* 三级菜单 */
.three_tree {
  background: #fff;
  /* position: absolute; */
}

.sidear_container {
  max-height: 100vh;
  overflow-y: auto;
}
::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}
</style>
